import { CSSProperties, InputHTMLAttributes } from 'react';
import styles from 'styles/components/common/forms/LabelInput.module.scss';
import classNames from 'classnames';
import { UseControllerProps, useFormContext } from 'react-hook-form';

type TProps<T> = InputHTMLAttributes<HTMLInputElement> & {
  name: string;
  inputType?: string;
  disabled?: boolean;
  placeholderText?: string;
  inputStyle?: CSSProperties;
  rules?: UseControllerProps['rules'];
  readonly?: boolean;
  handleFocus?: () => void;
  handleEnter?: () => void;
};

const Input = <T,>({
  name,
  inputType,
  disabled,
  placeholderText,
  inputStyle,
  rules,
  readOnly,
  handleFocus,
  handleEnter,
  ...rest
}: TProps<T>) => {
  const { register } = useFormContext();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleEnter && handleEnter();
    }
  };

  return (
    <input
      id={name}
      key={name}
      className={classNames(styles.input, {
        [styles.input_disabled]: disabled,
      })}
      {...register(name, rules)}
      type={inputType ? inputType : 'text'}
      disabled={disabled}
      placeholder={placeholderText}
      style={inputStyle}
      autoComplete="off"
      readOnly={readOnly}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
      {...rest}
    ></input>
  );
};
export default Input;
